import { createFileRoute, notFound } from "@tanstack/react-router";
import { PrayerSchedulePage } from "@/components/prayer/PrayerSchedulePage";
import { findKotaBySlug, getProvinsi } from "@/data/locations";
import { prayerCanonical, prayerJsonLd } from "@/lib/seo/prayer-schema";
import { displayLocationTitle } from "@/lib/prayer/copy";
import { EmptyLocationState } from "@/components/prayer/EmptyLocationState";
import { SiteShell } from "@/components/layout/SiteShell";

export const Route = createFileRoute("/jadwal-imsak/$kota/")({
  loader: ({ params }) => {
    const loc = findKotaBySlug(params.kota) ?? getProvinsi(params.kota);
    if (!loc) throw notFound();
    return { loc };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { loc } = loaderData;
    const display = displayLocationTitle(loc);
    const title = `Jadwal Imsakiyah ${display} - Sahur & Berbuka`;
    const desc = `Jadwal imsakiyah ${display}: Imsak, Subuh, Maghrib, Isya untuk sahur dan berbuka puasa.`;
    const canonical = prayerCanonical("imsak", loc);
    return {
      meta: [
        { title }, { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: canonical },
        { property: "og:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: desc },
        { name: "twitter:image", content: "https://hari.co.id/og-jadwal-imsak.svg" },
        { name: "robots", content: "index, follow, max-image-preview:large" },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(prayerJsonLd("imsak", loc)) }],
    };
  },
  component: () => {
    const { loc } = Route.useLoaderData();
    return <PrayerSchedulePage variant="imsak" location={loc} />;
  },
  notFoundComponent: () => (
    <SiteShell>
      <EmptyLocationState variant="imsak" />
    </SiteShell>
  ),
});
